module.exports = __webpack_public_path__ + "img/张慧敬.512ada30.jpg";